export enum RoleId {
  HDB_ADMIN = 1,
  TC_ADMIN = 2,
  TC_OPERATOR = 3,
  AGENCY_ADMIN = 4,
  AGENCY_OPERATOR = 5,
  AGENCY_USER = 6,
  SLS_SUPPLIER = 7,
  HDB_VIEW = 8,
  SLP_OPERATOR = 9,
}
